// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y-OjI","colBig":"styles_colBig__33z21","colSmall":"styles_colSmall__3l1fz","shopifyNameWrapper":"styles_shopifyNameWrapper__17L0g"};